import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "attd_install_hint_dismissed";

// Aviso para guardar el portal del asesor en la pantalla de inicio.
const InstallHint = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      setShow(localStorage.getItem(KEY) !== "1");
    } catch {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(KEY, "1");
    } catch {
      /* ignore */
    }
    setShow(false);
  };

  return (
    <div className="glass-panel rounded-lg p-4 md:p-5 border-accent-500/30 mb-6 animate-fade-up">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <span className="w-11 h-11 rounded-lg bg-accent-500/20 text-accent-200 flex items-center justify-center shrink-0">
          <i className="ri-smartphone-line text-xl" />
        </span>
        <div className="flex-1">
          <h3 className="editable-title text-sm font-bold">Guarda tu tienda en el celular</h3>
          <p className="text-xs text-foreground-600 mt-1">
            Abre el menú del navegador y elige <strong>“Agregar a pantalla de inicio”</strong> para
            tener tu portal a un toque.{" "}
            <Link to="/ingreso" className="text-accent-200 font-semibold">
              Ver cómo instalar
            </Link>
          </p>
        </div>
        <button
          onClick={dismiss}
          className="self-start sm:self-center px-3 py-1.5 rounded-md border border-background-300/50 text-foreground-600 hover:text-foreground-900 text-xs font-semibold whitespace-nowrap cursor-pointer"
        >
          Entendido
        </button>
      </div>
    </div>
  );
};

export default InstallHint;